'use client';
import s from './DynamicVideoEmbed.module.scss';

// preload="metadata": браузер тянет только первый кадр + длительность (small range-запрос),
// а не весь файл. Видео БОЛЬШОЕ (~115 МБ) — авто-проигрывание убрано, играем по клику,
// иначе страница «О нас»/главная тянут десятки МБ при заходе.
export const DynamicVideoEmbed = ({ src }: { src: string }) => {
  return (
    <div className={s.videoContainer}>
      <video
        preload="metadata"
        disablePictureInPicture
        playsInline
        controls
      >
        <source src={src} type="video/mp4" />
      </video>
    </div>
  );
};